/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import Introduction from "./Introduction/Introduction";
import Col from "../../UIcomponent/Column";
import "./Teacher.scss";
import LocalContext from "../../Context/LocalContetxt";
import TeacherBook from "./TeacherBook/TeacherBook";
import TeacherResume from "./TeacherResume/TeacherResume";
import Section from "../../UIcomponent/Section";
import StyledButton from "../../UIcomponent/Button";
import TeacherProfileReq from "../../Utility/Requester/TeacherProfileReq";
import DateTime from "../../Utility/Method/DateTime";
import MiniWeeklySchedule from "./MiniWeeklySchedule";
import TeacherReviews from "./TeacherReviews/TeacherReviews";
import BookingModal from "../../Component/BookingModal/BookingModal";
import BookingContext from "../../Context/BookingContext";
import axios from "axios";
import { ThemeContext } from "styled-components";
import LocalBooking from "../../Utility/Method/LocalBooking";
import WeeklyModal from "./WeeklyModal/WeeklyModal";
import Urls from "../../Utility/Urls";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";
import AparatPlayer from "../../Component/AparatPlayer";
import DashboardReq from "../../Utility/Requester/DashboardReq";
import { getGuid } from "../../App";
import Metas from "../../Component/Metas";
import Modal from "../../UIcomponent/Modal";
import LoginRegister from "../../Component/LoginRegister/LoginRegister";
import { PublicDic } from "../../Utility/PublicDic";

const yektaNetIds = {
  "mahsan-karimi": "6b3f01bf-48a6-4bca-b1bc-4c8443cc9041",
  "saeed-teimourian": "d55adcfd-68c4-49ad-a280-ce4e816efe6a",
  ghobadzadeh: "04f333dd-5d06-4932-a5bf-919ac2b63fa2",
  "abbas-mirzaie": "8be19bb7-2182-4154-9e35-24ad4d87d6ff",
  "malihe-tootoonchi": "45ffd3fe-3f8c-437c-9725-d6b16d2ffd16",
  "zahra-barati": "daca20c1-db7e-4af8-abce-744d848c445d",
  nikan: "test",
};

const Teacher = (props) => {
  const lang = useContext(LocalContext).lang;
  const ID = props.match.params.id;
  const theme = useContext(ThemeContext);
  const location = useLocation();
  let localBook = LocalBooking.Get();
  const [intro, setIntro] = useState(null);
  const [resume, setResume] = useState(null);
  const [review, setReview] = useState(null);
  const [reviewStats, setReviewStats] = useState(null);
  const [availableWeekly, setAvailableWeekly] = useState(null);
  const [DateStatus, setDateStatus] = useState([]);
  const [weeklyCell, setWeeklyCell] = useState([]);
  const [DailyCell, setDailyCell] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ShowBookModal, setShowBookModalOrg] = useState(false);
  const [showWeeklyModal, setShowWeeklyModal] = useState(false);
  const [BookingBtnDisable, setBookingBtnDisable] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const hasToken = useContext(LocalContext).hasToken;
  const [hadTrial, setHadTrial] = useState(false);

  function setShowBookModal(val) {
    if (!hasToken) {
      return setShowRegister(true);
    }
    if (val) {
      window.location.href = `/teachers/${ID}/book`;
    }
  }

  let price = {
    minPrice: intro != null && (intro.MinPrice || 0),
    trialPrice: intro != null && (intro.TrialPrice || 0),
  };

  useEffect(
    (_) => {
      if (window.ga)
        window.ga("ec:setAction", "detail", {
          id: getGuid(),
          step: 2,
        });
    },
    [window.ga]
  );

  let legalTime = 15 * 60 * 1 * 1000;
  let localBookInterval = localBook ? Date.now() - localBook.DateTime : 0;

  /* --- Life Cycle --- */
  const ScrollHandler = () => {
    if (scrolled === false && window.innerWidth > 768 && window.scrollY > 90) {
      setScrolled(true);
    }
    if (scrolled === true && window.innerWidth > 768 && window.scrollY <= 90) {
      setScrolled(false);
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // localBookInterval = localBook ? Date.now() - localBook.DateTime : 0;
    // setTimeout(() => {
    //   if (localBookInterval >= legalTime) {
    //     LocalBooking.Remove();
    //     window.location.reload();
    //   }
    // }, 0);
    // const CheckInterval = () =>
    //   setInterval(() => {
    //     localBookInterval = localBook ? Date.now() - localBook.DateTime : 0;
    //     if (localBookInterval >= legalTime) {
    //       LocalBooking.Remove();
    //       setShowBookModal(false);
    //       window.location.reload();
    //     }
    //   }, 6000000);
    // CheckInterval();

    let params = {
      timeZone: DateTime.timeZone(),
    };
    TeacherProfileReq.teacherInfoByUsername(params, ID)
      .then((res) => {
        let UID = res.data.UserID;
        let TID = res.data.TeacherID;
        let DATA = res.data;
        // TeacherProfileReq.usedTrials()
        //   .then((res) => {
        //     if (res.data.length == 3) {
        //       setHadTrial(true);
        //     } else {
        //       res.data.map((ses) => {
        //         if (ses.TeacherID == TID) {
        //           setHadTrial(true);
        //         }
        //       });
        //     }

        //   })
        //   .catch(() => setIntro(res.data));
        setHadTrial(true);

        setIntro(DATA);
        TeacherProfileReq.teacherResume(params, UID).then((res) => {
          let fileName = res.data.Resume;
          return axios({
            method: "GET",
            responseType: "json",
            baseURL: Urls.resume(),
            url: fileName,
          }).then((response) => {
            setResume(response.data);
          });
        });

        TeacherProfileReq.teacherWeekly(params, UID).then((res) => {
          let TimeSlot = [];
          TimeSlot =
            res.data !== null
              ? res.data.map((each) => {
                  if (DateTime.timeZone() === "Asia/Tehran") {
                    return {
                      ...each,
                      Start:
                        each.Start + 24 > 168
                          ? each.Start + 24 - 168
                          : each.Start + 24,
                      End:
                        each.End + 24 > 168
                          ? each.End + 24 - 168
                          : each.End + 24,
                    };
                  } else {
                    return {
                      ...each,
                    };
                  }
                })
              : [];
          LocalBooking.TimeSlot = TimeSlot;
          setAvailableWeekly(TimeSlot);
        });

        TeacherProfileReq.teacherReview(UID).then((res) => {
          setReview(res.data);
        });

        DashboardReq.ReviewStats(UID).then((res) => {
          setReviewStats(res.data);
        });

        localBook !== null && localBook.ID === Number(UID)
          ? LocalBooking.Set(localBook)
          : localBook && localBook.ID !== Number(UID)
          ? LocalBooking.Set({ ID: Number(UID) })
          : LocalBooking.Set({ ID: Number(UID) });

        if (
          performance.navigation.type === 1 &&
          localBook !== null &&
          localBook.PriceID
        ) {
          // setShowBookModal(true);
        }
      })

      .catch((err) => {
        window.location.href = "/404";
        console.log(err);
      });

    window.addEventListener("scroll", ScrollHandler);
    return () => {
      // CheckInterval && clearInterval(CheckInterval);
      window.removeEventListener("scroll", ScrollHandler);
    };
  }, []);

  const showWeeklyModalHandler = () => {
    setShowWeeklyModal(true);
  };
  const LoadMore = () => {
    if (!intro) {
      return;
    }
    let params = {
      Page: review.Paging.Page + 1,
      PageSize: 10,
    };
    TeacherProfileReq.teacherMoreReview(params, intro.UserID).then((res) => {
      setReview({
        ...review,
        Reviews:
          res.data.Reviews !== null
            ? [...review.Reviews, ...res.data.Reviews]
            : [...review.Reviews],
        Paging: res.data.Paging,
      });
    });
  };

  let metas = {};

  if (ID) {
    if (yektaNetIds[ID]) {
      metas["yn-tag"] = yektaNetIds[ID];
    }
  }

  return (
    <BookingContext.Provider
      value={{
        DateStatus,
        setDateStatus,
        weeklyCell,
        setWeeklyCell,
        DailyCell,
        setDailyCell,
      }}
    >
      {intro && intro.FirstName && intro != null && intro.FirstName != null && (
        <Metas
          title={`آموزش زبان با ${
            intro && `${intro.FirstName} ${intro.LastName}`
          } | لینگوتاک`}
          description={`شروع یادگیری زبان با ${
            intro && `${intro.FirstName} ${intro.LastName}`
          } در لینگوتاک`}
          additional={metas}
        >
          {Object.keys(metas).map((key) => {
            return <meta name={key} key={key} content={metas[key]} />;
          })}
        </Metas>
      )}
      {hasToken === false && showRegister && (
        <Modal visible={showRegister} onCancel={(_) => setShowRegister(false)}>
          <LoginRegister mode={"register"} />
        </Modal>
      )}
      <Col
        xl={19}
        lg={22}
        md={22}
        sm={22}
        xs={24}
        justifyContent="space-evenly"
        className="l__Teacher"
        height="auto"
        lang={lang}
      >
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="c__Video__RES"
          loading={loading}
        >
          {intro && (
            <AparatPlayer
              baseUrl={"https://api.lingotalk.io"}
              video={intro.IntroAparat}
              primary={theme.primary}
              height="202.5px"
              width="100%"
              borderRadius="0px 0px 0px 0px"
              secondary={"white"}
              overlay={theme.lightGlass}
            />
            // <ReactPlayer
            //   style={{
            //     outLine: "none",
            //     height: '2.2px'
            //   }}
            //   playing={false}
            //   controls={true}
            //   autoPlay={false}
            //   height="202.5px"
            //   width="100%"
            //   volume={0.5}
            //   url={Urls.video() + intro.IntroductionVideo}
            // />
          )}
        </Col>
        <Col
          xl={15.5}
          lg={15}
          md={15}
          sm={24}
          xs={22}
          className="c__Teacher__Main"
        >
          <Introduction {...props} intro={intro} />
          <MiniWeeklySchedule
            className="o__Teacher__Side__Schedule--RES"
            ID={intro ? intro.UserID : 0}
            available={availableWeekly}
            onClick={showWeeklyModalHandler}
            loading={loading}
            setLoading={setLoading}
            lang={lang}
            {...props}
          />
          {resume && (
            <Section className="o__Teacher__Side__Resume">
              <TeacherResume
                {...props}
                noAction
                noBorder
                teacher={intro}
                lang={lang}
                Resume={resume}
              />
            </Section>
          )}
          <TeacherReviews
            data={review}
            stats={reviewStats}
            intro={intro}
            LoadMore={LoadMore}
            {...props}
            lang={lang}
            theme={theme}
          />
        </Col>

        <>
          <Col
            xl={7}
            lg={7}
            md={8}
            sm={0}
            xs={6}
            className={`c__Teacher__Side`}
          >
            <TeacherBook
              ShowBookModal={ShowBookModal}
              setShowBookModal={setShowBookModal}
              disable={BookingBtnDisable}
              intro={intro}
              id={ID}
              hadTrial={hadTrial}
            />

            <MiniWeeklySchedule
              ID={intro ? intro.UserID : 0}
              available={availableWeekly}
              onClick={showWeeklyModalHandler}
              loading={loading}
              setLoading={setLoading}
              disable={BookingBtnDisable}
              className="o__Teacher__Side__Schedule"
              lang={lang}
              {...props}
            />
          </Col>
          {intro && (
            <BookingModal
              ID={intro ? intro.UserID : 0}
              onCancel={() => setShowBookModal(false)}
              stepCount={3}
              visible={ShowBookModal}
              setDisable={setBookingBtnDisable}
              intro={intro}
              PublicUsername={ID}
              hadTrial={hadTrial}
              {...props}
            />
          )}
          <WeeklyModal
            ID={intro ? intro.UserID : 0}
            loading={loading}
            setLoading={setLoading}
            disable={BookingBtnDisable}
            lang={lang}
            onConfirm={() => {
              setShowWeeklyModal(false);
              setTimeout(() => {
                setShowBookModal(true);
              }, 1);
            }}
            setShowWeeklyModal={setShowWeeklyModal}
            visible={showWeeklyModal}
          />
        </>
      </Col>
      <Col className="o__BookingButton--RES">
        <br />
        <Col
          className="c__TeacherBook__Session"
          xl={21}
          lg={21}
          md={21}
          sm={21}
          xs={21}
          skeletonType="line"
          loading={loading}
        >
          <br />
          {intro && (
            <>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="c__Session__Count"
              >
                شروع قیمت از ساعتی
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="c__Session__Price"
              >
                {price &&
                  (price.minPrice / 10).toLocaleString(lang) +
                    " " +
                    PublicDic.Toman}
              </Col>
            </>
          )}
          <br />
        </Col>
        <br />
        <StyledButton
          primary
          id={`booking_button_TeacherID:${ID}`}
          disable={BookingBtnDisable}
          secondary
          onClick={() => {
            if (!hasToken) {
              setShowRegister(true);
              return;
            }
            setShowBookModal(true);

            // window.location.href = `/teachers/${ID}/book`;
          }}
        >
          رزرو کلاس
        </StyledButton>
      </Col>
    </BookingContext.Provider>
  );
};

export default Teacher;
